import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Progress,
  Grid,
  Typography,
} from '@tq/ui-components';
import { tqc } from '@tq/ui-components/dist/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatBytes } from 'tools';
import { FileUploadProgress } from '../types';

export type UploadingModalProps = {
  uploadingFiles?: File[];
  progress: FileUploadProgress;
};
export const UploadingModal: React.FC<UploadingModalProps> = ({
  uploadingFiles,
  progress,
}) => {
  const { t } = useTranslation('file_upload');

  return (
    <Modal isOpen={!!uploadingFiles} onClose={() => null} isCentered>
      <ModalOverlay />
      <ModalContent mx={{ base: 10, lg: 5 }}>
        <ModalBody>
          <Grid py={15}>
            <Typography aria-hidden='true' textAlign='center' mb={15}>
              <h2>{t('uploading_documents', 'Uploading documents...')}</h2>
            </Typography>
            <Progress
              aria-hidden='true'
              colorScheme='#7ED321'
              borderRadius={4}
              value={progress.percent}
            />
            <Typography aria-hidden='true' display='flex' justifyContent='space-between'>
              <tqc.p>
                {t('uploaded', 'Uploaded')} {progress.percent}%
              </tqc.p>
              <tqc.p>
                {formatBytes(progress.bytesUploaded)} {t('of', 'of')}{' '}
                {formatBytes(progress.totalBytes)}
              </tqc.p>
            </Typography>
          </Grid>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
